import { createSlice } from "@reduxjs/toolkit";

export const site = createSlice({
  name: "site",
  initialState: {
    dark: false,
    language: "tr",
    sideBtn: true,
    pageName: "",
  },
  reducers: {
    setDarkMode: (state) => {
      state.dark = !state.dark;
    },
    setLanguage: (state, action) => {
      state.language = action.payload;
    },
    setSideBtn: (state) => {
      state.sideBtn = !state.sideBtn;
    },
    setPageName: (state, action) => {
      state.pageName = action.payload;
    }

  },
});

export const { setDarkMode, setLanguage, setSideBtn, setPageName } = site.actions;

export default site.reducer;
